import React from "react";
import Spin from "antd/lib/spin";
import "antd/dist/antd.less";

export default (props) => (
  <div style={{ display: "flex" }}>
    <Spin
      style={{ margin: "auto" }}
      alt="loader"
      height={props.height || 80}
      width={props.width || 80}
      tip={props.tip || "Calcul en cours..."}
    />
  </div>
);
